import React from 'react';
import '../Style/SkillRadarChart.css';
import {
  Radar,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  Legend,
  ResponsiveContainer,
} from 'recharts';

const hardSkill = [
  { subject: 'LLM', A: 4, fullMark: 5 },
  { subject: 'SwiftUI', A: 3, fullMark: 5 },
  { subject: 'HTML/CSS', A: 3, fullMark: 5 },
  { subject: 'Java', A: 3, fullMark: 5 },
  { subject: 'JavaScript', A: 3, fullMark: 5 },
  { subject: 'Unity', A: 4, fullMark: 5 },
  { subject: 'C#', A: 3, fullMark: 5 },
  { subject: 'UdonSharp', A: 5, fullMark: 5 },
  { subject: 'VRChatSDK', A: 5, fullMark: 5 },
  { subject: 'Swift', A: 2, fullMark: 5 },
  { subject: 'Git', A: 4, fullMark: 5 },
  { subject: 'Blender', A: 2, fullMark: 5 },
];

const softSkill = [
  { subject: 'Problem solving', A: 5, fullMark: 5 },
  { subject: 'WBS', A: 2, fullMark: 5 },
  { subject: 'Proactive', A: 3, fullMark: 5 },
  { subject: 'Communication', A: 3, fullMark: 5 },
  { subject: 'Support', A: 4, fullMark: 5 },
];

const chartTextColor = 'var(--color-text)';
const chartGridColor = 'var(--color-border)';
const hardSkillColor = '#8884d8';
const softSkillColor = '#82ca9d';

const SkillRadarChart = () => {
  return (
    <>
      <h1 className="textCenter">My Skills</h1>
      <div className="chartContainer">
        <div className="chartWrapper">
          <ResponsiveContainer width="100%" height={400}>
            <RadarChart cx="50%" cy="50%" outerRadius="80%" data={hardSkill}>
              <PolarGrid stroke={chartGridColor} />
              <PolarAngleAxis
                dataKey="subject"
                tick={{ fill: chartTextColor }}
              />
              <PolarRadiusAxis
                angle={30}
                domain={[0, 5]}
                tickCount={6}
                tick={{ fill: chartTextColor }}
              />
              <Radar
                name="HARD SKILLS"
                dataKey="A"
                stroke={hardSkillColor}
                fill={hardSkillColor}
                fillOpacity={0.6}
              />
              <Legend wrapperStyle={{ color: chartTextColor }} />
            </RadarChart>
          </ResponsiveContainer>
        </div>
        <div className="chartWrapper">
          <ResponsiveContainer width="100%" height={400}>
            <RadarChart cx="50%" cy="50%" outerRadius="80%" data={softSkill}>
              <PolarGrid stroke={chartGridColor} />
              <PolarAngleAxis
                dataKey="subject"
                tick={{ fill: chartTextColor }}
              />
              <PolarRadiusAxis
                angle={30}
                domain={[0, 5]}
                tickCount={6}
                tick={{ fill: chartTextColor }}
              />
              <Radar
                name="SOFT SKILLS"
                dataKey="A"
                stroke={softSkillColor}
                fill={softSkillColor}
                fillOpacity={0.6}
              />
              <Legend wrapperStyle={{ color: chartTextColor }} />
            </RadarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </>
  );
};

export default SkillRadarChart;
